module.exports = __webpack_public_path__ + "img/ic_market_set.0a7ba81e.svg";